import { render, staticRenderFns } from "./SelectedBiz.vue?vue&type=template&id=09cb7205&scoped=true&"
import script from "./SelectedBiz.vue?vue&type=script&lang=js&"
export * from "./SelectedBiz.vue?vue&type=script&lang=js&"
import style0 from "./SelectedBiz.vue?vue&type=style&index=0&id=09cb7205&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb7205",
  null
  
)

export default component.exports